import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import React from 'react';
import { COLOR } from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';
import useSiteNavContext from './SiteNavContext';
import { SITE_NAV_MODE } from './SiteNavUtils';
import { StyledSiteNavButton } from './StyledSiteNav';

const HamburgerButton = () => {
  const { setNavMode } = useSiteNavContext();

  return (
    <StyledSiteNavButton
      onClick={() => setNavMode(SITE_NAV_MODE.HamburgerMenu)}
    >
      <Icon icon={faBars} color={COLOR.white} size={16} />
    </StyledSiteNavButton>
  );
};

export default HamburgerButton;
